import React, { FC, useMemo } from 'react';
import History from 'src/components/History';
import { ClaimChangelogType } from 'src/types/claimDetail';
import { ConstantsCodesObjectType } from 'src/types/constantsCodes';
import { historyProductUpdates, historyUpdates, historyUpdatesSkladonUser, historyClaimFilesUpdates, historyCreateHiddenKeys } from './constants';
import translate from '@translate';
import { ClaimErrorCategories, ClaimErrorDepartments, ClaimErrorSeverities } from 'skladon-types';

export interface HistoryPropsType {
    changelog: ClaimChangelogType | null;
    claimStatusCodesObject: ConstantsCodesObjectType;
    claimReasonCodesObject: ConstantsCodesObjectType;
    claimsResolverCodesObject: ConstantsCodesObjectType;
    skladonUser?: number;
    lineStateCodesObject: ConstantsCodesObjectType;
    boolNumberCodesObject: ConstantsCodesObjectType;
}

const HistoryBlock: FC<HistoryPropsType> = (props) => {
    const claimErrorDepartmentCodesObject = useMemo(
        () =>
            Object.fromEntries(
                ClaimErrorDepartments.map((value) => [
                    value,
                    { value, label: translate(`claimDetail.errorDepartment.${value}`) }
                ])
            ) as ConstantsCodesObjectType,
        []
    );
    const claimErrorCategoryCodesObject = useMemo(
        () =>
            Object.fromEntries(
                ClaimErrorCategories.map((value) => [
                    value,
                    { value, label: translate(`claimDetail.errorCategory.${value}`) }
                ])
            ) as ConstantsCodesObjectType,
        []
    );
    const claimErrorSeverityCodesObject = useMemo(
        () =>
            Object.fromEntries(
                ClaimErrorSeverities.map((value) => [
                    String(value),
                    { value, label: translate(`claimDetail.errorSeverity.${value}`) }
                ])
            ) as ConstantsCodesObjectType,
        []
    );

    return (
        <History
            updates={props.changelog?.updates}
            updateKeys={props.skladonUser ? historyUpdatesSkladonUser : historyUpdates}
            updateItemsKeys={{
                PRODUCTS: { requiredItems: ['SKU'], itemKeys: historyProductUpdates },
                CLAIM_FILES: {
                    requiredItems: ['FILE.ORIGINAL_FILE_NAME'],
                    itemKeys: historyClaimFilesUpdates,
                },
            }}
            keyCodes={{
                STATUS: props.claimStatusCodesObject,
                CLAIM_CAUSE: props.claimReasonCodesObject,
                RESOLVER: props.claimsResolverCodesObject,
                CCTV: props.boolNumberCodesObject,
                ERROR_DEPARTMENT: claimErrorDepartmentCodesObject,
                ERROR_CATEGORY: claimErrorCategoryCodesObject,
                ERROR_SEVERITY: claimErrorSeverityCodesObject,
            }}
            keyItemsCodes={{
                PRODUCTS: {
                    LINE_STATE: props.lineStateCodesObject,
                },
            }}
            translatePrefix="claimDetail"
            createHiddenKeys={historyCreateHiddenKeys}
        />
    );
};

export default HistoryBlock;
